
<template>
  <zm-modal
    ref="modal"
    @ok="handleSubmit"
    :title="title"
    :visible="visible"
    size="middle"
    @cancel="open(false)"
  >
    <div slot="modalBody" class="cancel_application">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门名称" hasFeedback>
          <a-input
            autocomplete="off"
            placeholder="请输入部门名称"
            v-decorator="['name', { rules: [{ required: true, message: '请输入部门名称!' },
              { pattern: /^[^\s]*$/, message: '部门名称不能包含空格！' },
              { max: 50, message: '最多可输入50个字符' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门主管" hasFeedback>
          <a-select
            :allowClear="true"
            placeholder="请选择部门主管"
            mode="multiple"
            :maxTagCount="2"
            showSearch
            optionFilterProp="children"
            :filterOption="filterOption"
            v-decorator="['heads', { rules: [{ required: false, message: '请选择部门主管!' }] }]"
          >
            <a-select-option v-for="(item, index) in userList" :value="item.id" :key="index">
              {{ item.userName }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
  </zm-modal>
</template>

<script>
import { createSysDept, editSysDept, getUserBaseInfo } from '@/api/baseInfo'
export default {
  name: 'editDept',
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
  },
  components: {},
  data () {
    return {
      title: '操作',
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'inquiry' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      colSpan: 24,

      userList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
      if (flag) {
        this.initDictData()
        if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
          this.setModelInfo()
        }
      } else {
        this.formClear()
      }
    },
    setModelInfo () {
      const heads = this.model.headList.map(item => { return item.headId })
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: this.model.name,
          heads: heads.length ? heads : undefined
        })
      })
    },
    // 提交表单
    handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value }
          const headList = params.heads ? this.userList.filter(item => params.heads.indexOf(item.id) > -1) : []
          params.headList = headList.map(item => {
            return { headId: item.id, headName: item.userName }
          })
          delete params.deads

          if (this.type === this.$sysInfo.MODAL_ADD) {
            if (this.model.pNode) {
              params.pid = this.model.pNode.id
              // params.level = this.model.pNode.level + ',' + this.model.pNode.id
            } else {
              params.pid = 0
              // params.level = '0'
            }
            this.$refs.modal.handleOkLoading(true)

            const res = await createSysDept(params).catch(() => {
              this.$refs.modal.handleOkLoading(false)
              this.$message.error('操作失败，请重试！')
            })
            this.$refs.modal.handleOkLoading(false)
            if (res.status === 0) {
              this.$message.success('新增成功')
              this.$emit('refresh')
              this.cancel()
            } else {
              this.$message.warning(res.info.message)
            }
          } else {
            params.id = this.model.id
            params.pid = this.model.pid
            // params.level = this.model.level

            // if (this.model.status === 3) {
            //   params.status = 0
            // }
            this.$refs.modal.handleOkLoading(true)

            const res = await editSysDept(params).catch(() => {
              this.$refs.modal.handleOkLoading(false)
              this.$message.error('操作失败，请重试！')
            })
            this.$refs.modal.handleOkLoading(false)
            if (res.status === 0) {
              this.$message.success('编辑成功')
              this.$emit('refresh')
              this.cancel()
            } else {
              this.$message.error(res.info.message)
            }
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.model = {}
        this.form.resetFields()
        //
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 获取select列表
    initDictData () {
      getUserBaseInfo({ status: 1, paging: false }).then(res => {
        if (res.status === 0) {
          this.userList = res.data.map(item => {
            return { id: item.id, userName: item.userName }
          })
        }
      })
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less">
.info_label{
  margin-bottom: 10px;
}
</style>

